// ts-nocheck
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { updateCoachInfo } from "../store/postsSlice";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../Constants/BaseUrl";

const EditCoachProfileModal = ({
  visible,
  setModalVisible,
  userDetails,
  navigation,
}) => {
  const dispatch = useAppDispatch();
  const [form, setForm] = useState({
    username: "",
    first_name: "",
    last_name: "",
    college: "",
    sport_id: "",
  });

  useEffect(() => {
    console.log(userDetails, "userDetailsuserDetailsuserDetails");
    if (userDetails) {
      setForm({
        username: userDetails?.username ?? "",
        first_name: userDetails?.coach_info?.first_name ?? "",
        last_name: userDetails?.coach_info?.last_name ?? "",
        college: userDetails?.coach_info?.college ?? "",
        sport_id: userDetails?.coach_info?.sport_id ?? "",
      });
    }
  }, [userDetails]);

  const [loading, setLoading] = useState(false);
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const [sports, setSports] = useState([]);

  const getSports = () => {
    let config = {
      url: `${BASE_URL}sports/all`,
      headers: {
        Accept: "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setSports(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getSports();
  }, []);

  const validateForm = () => {
    for (const key in form) {
      if (!form[key]) {
        console.log(`Please fill out the ${key} field.`);
        alert(`Please fill out the ${key} field.`);
        return false;
      }
    }
    return true;
  };

  const handleSaveDetails = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const payload = { form };
      console.log(payload);
      const result = await dispatch(updateCoachInfo(form)).unwrap();
      setModalVisible(false);
      toast.success("Profile saved successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.error(
        "Failed to save profile. Something went wrong while saving.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {visible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-80">
          <div className="bg-gray-900 text-white w-full max-w-lg p-6 rounded-lg max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <div></div>
              <button
                className="p-2 bg-gray-800 rounded-full"
                onClick={() => setModalVisible(false)}
              >
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <h2 className="text-xl font-semibold text-center mb-6">
              EDIT YOUR PROFILE
            </h2>

            <div className="px-8">
              {[
                { key: "username", placeholder: "Choose Username" },
                { key: "first_name", placeholder: "First Name" },
                { key: "last_name", placeholder: "Last Name" },
                { key: "college", placeholder: "College" },
              ].map((field) => (
                <input
                  key={field.key}
                  className="w-full bg-gray-800 border border-gray-600 rounded-md p-3 mb-4 text-white placeholder-gray-400"
                  placeholder={field.placeholder}
                  value={form[field.key]}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                />
              ))}

              <select
                className="w-full bg-gray-800 border border-gray-600 rounded-md p-3 mb-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600"
                value={form.sport_id}
                onChange={(e) => handleChange("sport_id", e.target.value)}
              >
                <option value="" disabled hidden className="text-gray-400">
                  Select Sport
                </option>
                {sports
                  ?.slice()
                  .sort((a: any, b: any) =>
                    a.sport_name.localeCompare(b.sport_name)
                  )
                  .map((opt: any) => (
                    <option
                      key={opt.id}
                      value={opt.id}
                      className="text-white bg-gray-800"
                    >
                      {opt.sport_name}
                    </option>
                  ))}
              </select>

              <button
                disabled={loading}
                onClick={handleSaveDetails}
                className="w-full bg-red-600 text-white py-2 rounded-md hover:bg-red-700 transition disabled:opacity-50"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-white mx-auto"></div>
                ) : (
                  <span className="text-base font-semibold">SAVE DETAILS</span>
                )}
              </button>

              <button
                onClick={() => {
                  navigate("/change-password-user", {
                    state: { email: user.email, isApp: true },
                  });
                  setModalVisible(false);
                }}
                className="w-full bg-gray-600 text-white py-2 rounded-md hover:bg-gray-700 transition mt-2"
              >
                CHANGE PASSWORD
              </button>
              <button
                onClick={() => {
                  setModalVisible(false);
                  navigate("/blocked-users");
                }}
                disabled={loading}
                className="w-full bg-gray-600 text-white py-2 rounded-md hover:bg-gray-700 transition mt-2"
              >
                BLOCKED USERS
              </button>

              <button
                onClick={() => {
                  navigate("/logout");
                  setModalVisible(false);
                }}
                className="w-full bg-gray-600 text-white py-2 rounded-md hover:bg-gray-700 transition mt-2"
              >
                LOG OUT
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditCoachProfileModal;
